<template>
   <div class="admin-keyboard"></div>
</template>

<script>
import KeyboardSimple from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
   name: "AdminKeyboard",
   props: {
      keyboardClass: {
         default: "admin-keyboard",
         type: String
      },
      input: {
         type: String
      }
   },
   data () {
      return {
         keyboard:{},
      }
   },
   watch: {
      input(input) {
         this.keyboard.setInput(input);
      }
   },
   mounted() {
      this.keyboard = new KeyboardSimple(".admin-keyboard",{
         theme: "simple-keyboard code-kbd",
         onChange: input => this.onChange(input),
         onKeyPress: button => this.onKeyPress(button),
         preventMouseDownDefault: true,
         stopMouseDownPropagation: true,
         disableCaretPositioning: true,
         newLineOnEnter: false,
         maxLength: 4,
         layout: {
            default: ["1 2 3", "4 5 6", "7 8 9", "0 {bksp} {enter}"
         ]},
         display: {
            "{escape}": "esc ⎋",
            "{tab}": "⇥",
            "{bksp}": "⌫",
            "{enter}": "✓",
            "{lock}": "⬆",
            "{space}": " ",
            "{//}": " ",
            "{shift}": "⇧",
         },
         buttonTheme: [{
            class: "admin-btn",
            buttons: "1 2 3 4 5 6 7 8 9 0 {bksp} {enter}"
         }]

         });
         //let kbd = this.keyboard;

         console.log("keyboard admin " + this.keyboard);
      },
      methods: {
         setInput(val) {
            //let input = e.target.value;
            this.keyboard.setInput(val);
         },
         onChange(input) {
            this.$emit("onChange", input);
         },
         onKeyPress(button) {
            this.$emit("onKeyPress", button);

            if (button === "{enter}")
            this.$emit('enter');
         }
      },
   };
   </script>

   <!-- Add "scoped" attribute to limit CSS to this component only -->
   <style>

   .admin-keyboard {
      font-family: 'Univers Condensed';
      font-size: 20px;
      width: 286px;
      //max-width: 286px;
      //transform: scale(1);
      margin-top: 40px;
      margin-left: auto;
      margin-right: auto;
      pointer-events: auto;
      //overflow: visible;
      background-color: rgba(255, 255, 255, 1));
   }

   .code-kbd{
      background: transparent;
   }


    .admin-btn {
      box-shadow: none;
      height: 70px;
      border-radius: 20px;
      box-sizing: border-box;
      padding: 23px;
      margin: 10px;
      background: #ebebeb;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
}

   /* .simple-keyboard.code-kbd .hg-row .hg-button {
     height: 50px;
     display: flex;
     justify-content: center;
     align-items: center;
     background: blue;
     color: red;
   }

   .simple-keyboard.code-kbd .hg-button:active {
     background: #1c4995;
     color: white;
   }
 */

   </style>
